<template>
  <main class="complaint-record-page">
    <header class="head">
      <div class="head-glow"></div>
      <h1>投诉记录</h1>
    </header>

    <section class="record-list" v-if="list.length">
      <article class="record-item" v-for="(item,index) in list" :key="index" @click="handleItemClick(item)">
        <div class="item-head">
          <div class="text-1">{{ item.create_time }}</div>
          <div class="right" :class="item.result ? 'done' : 'pending'">{{ item.result ? "已处理" : "处理中" }}</div>
        </div>
        <div class="text-2"><span class="info-label">联系人：</span><span class="info-value">{{ item.name || "--" }}</span></div>
        <div class="text-2"><span class="info-label">联系电话：</span><span class="info-value">{{ item.mobile || "--" }}</span></div>
        <div class="text-2 desc-row"><span class="info-label">问题：</span><span class="info-value">{{ item.desc || "--" }}</span></div>
      </article>
    </section>

    <section class="empty" v-else>
      <img class="empty-illust" src="./static/images/complaint-record/Frame.png" alt="" aria-hidden="true">
      <p>暂无记录～～</p>
    </section>

    <van-dialog v-model="modal" :showConfirmButton="false" width="88%" :closeOnClickOverlay="true">
      <div class="detail-dialog">
        <div class="detail-line"><span class="info-label">投诉时间：</span><span class="info-value">{{ one.create_time || "--" }}</span></div>
        <div class="detail-line"><span class="info-label">联系人：</span><span class="info-value">{{ one.name || "--" }}</span></div>
        <div class="detail-line"><span class="info-label">联系电话：</span><span class="info-value">{{ one.mobile || "--" }}</span></div>
        <div class="detail-line detail-desc"><span class="info-label">问题详情：</span><span class="info-value">{{ one.desc || "--" }}</span></div>
        <div class="detail-line detail-files">
          <span>附件：</span>
          <img v-for="(img,index) in one.files" :key="index" :src="img" class="detail-file-img" @click="showImg(img)">
        </div>
        <div class="detail-line detail-desc"><span class="info-label">处理结果：</span><span class="info-value">{{ one.result || "暂未处理" }}</span></div>
      </div>
    </van-dialog>
  </main>
</template>

<script>
export default {
  name: "tousujiluNew",
  data () {
    return { one: {}, list: [], modal: false }
  },
  methods: {
    handleItemClick (item) {
      this.one = item || {}
      this.modal = true
    },
    getList () {
      this.fetchData("/user/feedlist", {}, (res) => {
        if (res.code) this.list = res.data || []
      })
    },
    showImg (url) {
      this.$dialog.alert({
        title: false,
        width: "60%",
        showConfirmButton: false,
        closeOnClickOverlay: true,
        message: `<img style="display:block;width:100%" src="${url}"/>`
      })
    }
  },
  created () {
    this.getList()
  }
}
</script>

<style scoped src="./static/css/complaint-record.css"></style>
<style scoped>
.record-list {
  padding: .24rem .2rem .3rem;
}

.complaint-record-page {
  background: #efefef;
}

.record-item {
  position: relative;
  width: 100%;
  box-sizing: border-box;
  padding: .16rem .18rem;
  border-radius: .16rem;
  border: 1px solid #ececec;
  box-shadow: none;
  margin-bottom: .24rem;
  background: #fff;
}

.item-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: .1rem;
  padding-bottom: .1rem;
  border-bottom: 1px solid #e5e5e5;
}

.text-1 {
  font-size: .14rem;
  color: #1e96ff;
  line-height: 1.35;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 2rem;
}

.text-2 {
  color: #000;
  line-height: 1.5;
  font-size: .14rem;
  word-break: break-all;
  margin-top: .02rem;
}

.desc-row .info-value {
  display: inline-block;
  max-width: 2.12rem;
  vertical-align: top;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.info-label {
  color: #5f5f5f;
  display: inline-block;
  min-width: .88rem;
}

.info-value {
  color: #1f1f1f;
}

.right {
  font-size: .15rem;
  line-height: 1.2;
  padding: 0;
}

.right.done {
  color: #8a8a8a;
}

.right.pending {
  color: #ff3b30;
}

.detail-dialog {
  padding: .16rem .14rem;
  max-width: 100%;
  box-sizing: border-box;
}

.detail-line {
  font-size: .14rem;
  line-height: 1.55;
  word-break: break-all;
}

.detail-desc {
  margin-top: .08rem;
}

.detail-files {
  margin: .12rem 0;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: .08rem;
}

.detail-file-img {
  width: .64rem;
  height: .64rem;
  vertical-align: middle;
  border-radius: .04rem;
}
</style>



// WEBPACK FOOTER //
// src/newpage/tousujilu.vue